/*********************** Custom JS for Boost AI Search & Discovery  ************************/
class BoostCollection {
  constructor() {
    this.items = [];
    this.attempts = 20;
    this.timeBetweenAttempts = 300;
    this.init();
  }

  init() {
    this.getBoostItems();
  }

  async getBoostItems() {
    this.items = document.querySelectorAll(".boost-sd__product-item");
    if (this.items.length === 0 && this.attempts > 0) {
      this.attempts--;
      setTimeout(() => this.getBoostItems(), this.timeBetweenAttempts);
    } else {
      this.injectBasicWishlist();
    }
  }

  injectBasicWishlist() {
    this.items.forEach((item) => {
      const currentProductId = parseInt(item.dataset.productId) || 0;
      const wrapper = item.querySelector(
        ".boost-sd__product-item-grid-view-layout-image"
      );
      const basicWishlist = this.getBasicWishlistHTML(currentProductId);
      wrapper.insertAdjacentHTML("afterbegin", basicWishlist);

      const inventoryStatus = item.querySelector(".boost-sd__inventory-status");
      if (inventoryStatus && inventoryStatus.textContent !== ".") {
        inventoryStatus.classList.add("--is-visible");
      }

      item
        .querySelectorAll(".boost-sd__button--show-on-hover")
        .forEach((button) => {
          button.addEventListener("focus", () => {
            item.classList.add("--is-focus");
          });
          button.addEventListener("blur", () => {
            item.classList.remove("--is-focus");
          });
        });
    });
  }

  getBasicWishlistHTML(currentProductId) {
    return `
      <button data-product-id="${currentProductId}" class="product_${currentProductId}--card product-wishlist--button --fetch">
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="11" cy="11" r="10.5" fill="#E0E0E0" stroke="black"/>
          <circle cx="11.0002" cy="10.9999" r="7.92105" fill="white" stroke="black"/>
          <path d="M11 5.73682V16.2631" stroke="black" stroke-width="2" stroke-linecap="round"/>
          <path d="M5.7373 11L16.2636 11" stroke="black" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>`;
  }
}

const boostCollection = new BoostCollection();

const customize = {
  updateBtns: (componentRegistry) => {
    componentRegistry.useComponentPlugin("ProductItem", {
      name: "Modify Product Buttons",
      enabled: true,
      apply: () => ({
        afterRender(element) {
          let product_id = element.getParams().props.product.id;
          let productItem = document.querySelector(
            '[data-product-id="' + product_id + '"]'
          );
          let product_data = element.getParams().props.product;
          if(!productItem.querySelector('.boost-sd__product-item-variant-info')) {
            productItem
              .querySelector(".boost-sd__product-info .boost-sd__product-price")
              .insertAdjacentHTML('afterend',buildVariantInfo(product_data));
          }
          
        },
      }),
    });
    componentRegistry.useComponentPlugin("ProductPrice.FormatCurrency", {
      name: "Modify Product Price format",
      enabled: true,
      apply: () => ({
        afterRender(element) {
          const money = element.getParams().props.value;
          const formatType = element.getParams().props.formatWithCurrency
                              ? window.boostSDAppConfig?.shop?.money_format_with_currency
                              : window.boostSDAppConfig?.shop?.money_format;
          const newPrice = element.getHelpers().formatMoney(money,formatType,true);
					element.getRootElm().innerHTML = newPrice;
        },
      }),
    });
    componentRegistry.useModulePlugin('SearchAPI', {
          name: 'Extra params SearchAPI',
          apply(builder) {
      
            // Logic run filter in search page, please only edit in TODO: do something - ts
            builder.on('beforeMethodCall', 'searchInCollection', (payload) => {
              const filterParams = payload.args[0];
              let isApiFilterInSearchPage = false;
              if(!filterParams) return;
              
              const keys = Object.keys(filterParams);
              if(keys?.length > 0) {
                for(let i = 0; i < keys.length; i++) {
                  if(keys[i].startsWith('pf_')) {
                    isApiFilterInSearchPage = true;
                    break;
                  }
                }
              }
              
              if(isApiFilterInSearchPage) {
                // TODO: do something - ts
                if(payload.args[0].pf_v_vendor) {
                  payload.args[0]['pf_v_vendor[]'] = payload.args[0].pf_v_vendor;
                }
                console.log("payload filter in Search Page", payload);
              }
            });   
          },
    });
  },
  /* Starts Boost 203430 */
  filterUsedProducts: (componentRegistry) => {
    componentRegistry.useModulePlugin("SearchAPI", {
      name: "Hide used products on vendors collection",
      apply(builder) {
        builder.on("beforeMethodCall", "searchInCollection", (payload) => {
          //   // TODO: do something - ts
          //   // example add pf_t_tag
          if (isVendorPage() == true) {
            payload.args[0].h_options = payload.args[0].h_options
              ? payload.args[0].h_options.concat("usedvv")
              : ["usedvv"];
          }
        });
      },
    });
  },
};
const isVendorPage = () => {
  return window.location.pathname.indexOf("/collections/vendors") > -1
    ? true
    : false;
};
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  customize.updateBtns,
  customize.filterUsedProducts,
]);

function outerHTML(node){
 return node.outerHTML || new XMLSerializer().serializeToString(node);
}
function buildVariantInfo(data) {
  const vLabel = buildVariantLabel(data.options_with_values);
  return vLabel !== '' ? '<span class="boost-sd__product-item-variant-info">' + vLabel + '</span>' : '';
}

function buildVariantLabel(data) {
  let variantInfo = [];
  data.forEach(element => {
    if(element.name !== 'title') {
      variantInfo.push({name: capitalize(element.name),  count: element.values.length});
    }
  });
  variantInfo.sort(function(a, b) { return a.name.charAt(0) > b.name.charAt(0) ? 1 : -1; });
  return variantInfo.map(element => variantLabel(element)).join(' | ');
}

function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

function variantLabel(option) {
  const vLabel = option.count + ' ' + option.name;
  return option.count > 1 ? vLabel + 's' : vLabel;
}